const n = window.$ || window.jQuery;
document.addEventListener('DOMContentLoaded', () => {
  if (typeof n > 'u') {
    window.console.error('jQuery is required for custom.js');
    return;
  }
  n(document).ready(() => {
    const e = new MutationObserver((s) => {
      const t = document.querySelector('#status-app');
      if (!t) return;
      const r = t.shadowRoot,
        o = document.createElement('style');
      (o.innerHTML =
        '@media screen and (max-width: 749px) { .me-button { font-size:10px!important; } .me-button svg { width:16px!important; height:16px!important;} }'),
        r.appendChild(o),
        e.disconnect();
    });
    e.observe(document.body, {childList: !0, subtree: !0});
  });
});
